import { Link, Navigate, Route, Routes } from "react-router";
import LoadingIcon from "./components/shared/LoadingIcon";
import LandingPage from "./pages/Landing";
import { useSocket } from "./contexts/SocketContext";
import GameRoomPage from "./pages/GameRoom";
import JoinRoomPage from "./pages/JoinRoom";
import {AceLogo, ExitIcon, LikeIcon, ListIcon, VolumeHighIcon, VolumeMuteIcon} from "./assets/icons";
import Modal from "./components/Modal";
import ContextMenu, { ContextMenuContent } from "./components/shared/modals/ContextMenu";
import { useState } from "react";
import HowToPlayPage from "./pages/HowToPlay";
import { getRelativeDate } from "./tools/helpers";
import formatEventLog from "./tools/formatEventLog";
import AttributionsModal from "./components/shared/modals/AttributionsModal";
import SoundManager from "./tools/SoundManager";
import FAQPage from "./pages/FAQPage";
import { Privacy, Terms } from "./pages/Legal";

//TODO/FIXMES
//admin switch to dead player game stalls -- this was probably just the fixed rejoin on deal next round bug
//admin end game without leave room
//maybe spectator see cards
//2d mode
//john disconnected right before game ended and it didn't show in room
//glitch where you can't see bot opponent card (once) after player leave
//glitch where main card suits don't appear after disconnect/rejoin
//deal card animation consistenly freezes up on slower pcs -- not the animation at fault but position data isn't updated

const App = () => {

  const {isInitializing} = useSocket();
  
  return (
    <div className="root-inner">
      {isInitializing
        ? <SplashScreen />
        : <MainRouter />
      }
    </div>
  );
}

const MainRouter = () => {
  
  return (
    <ContextWrapper>
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="room/:roomCode" element={<GameRoomPage />} />
        <Route path="join/:roomCode" element={<JoinRoomPage />} />
        <Route path="how" element={<HowToPlayPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        {GlobalPages()}
      </Routes>
      <GlobalComponents />
    </ContextWrapper>
  )
}

const GlobalPages = () => {
  // for if you have multiple routers and these pages need to be accessible in both
  return (
    <>
      <Route path="*" element={<Navigate to={'/'} />} />
    </>
  )
}

const GlobalComponents = () => {
  const {room, leaveRoom, game, recentEventLogs} = useSocket();

  const [menuVisible, setMenuVisible] = useState(false);
  const [logsVisible, setLogsVisible] = useState(false);
  const [attributionVisible, setAttributionVisible] = useState(false);

  const menuData: ContextMenuContent = {
    focusedItem: false,
    title: 'Options',
    menuContent: [
      {
        title: 'View Game Logs',
        icon: ListIcon,
        handleClick: () => setLogsVisible(true),
        visible: !!game || !!recentEventLogs.length
      },
      {
        title: `${SoundManager.isMuted() ? "Unmute" : "Mute"} Audio`,
        icon: SoundManager.isMuted() ? VolumeHighIcon : VolumeMuteIcon,
        handleClick: () => SoundManager.toggleMute(),
        visible: !!room
      },
      {
        title: 'Leave Room',
        icon: ExitIcon,
        handleClick: leaveRoom,
        visible: !!room,
        alert: true
      },
      {
        title: 'Attributions',
        icon: LikeIcon,
        handleClick: () => setAttributionVisible(true),
        newSection: !!room
      }
    ]
  }

  return (
    <>
      {attributionVisible && <AttributionsModal setModalVisible={setAttributionVisible} /> }
      {logsVisible && <GameLogsModal setModalVisible={setLogsVisible} />}
      {menuVisible && <ContextMenu menuData={menuData} setModalVisible={setMenuVisible} />}
      <nav aria-label="primary" className="right-item-layout">
        <Link to={'/'}><AceLogo /></Link>
        <button onClick={() => setMenuVisible(true)} className="primary short">Options</button>
      </nav>
      {/* <div className="crt" /> */}
    </>
  )
}

const GameLogsModal = ({setModalVisible}: {setModalVisible: (prev: boolean) => void}) => {

  const {eventLogs} = useSocket();

  return (
    <Modal
      bottomPane
      controls
      modalTitle={"Game Logs"}
      scroll
      setModalVisible={setModalVisible}
      maxHeightSize={'med'}
    >
      <div className="item-list">
        <p className="subheading-medium secondary">Most Recent</p>
        {[...eventLogs].reverse().map((log, i) =>
          <div key={i} className="item-row">
            <p className="body">
              {formatEventLog(log)}
              <span className="secondary"> {getRelativeDate(log.time)}</span>
            </p>
          </div>
        )}
        <p className="body secondary">Beginning of logs.</p>
      </div>
    </Modal>
  )
}

const ContextWrapper = ({children}: {children: React.ReactNode}) => {
  return (
    <>{children}</>
  );
}

const SplashScreen = () => {
  return (
    <div className="item-list center-vertical center-horizontal xl-gap full-height">
      <div className="logo">
        <div className="icon-display hero">
          <AceLogo />
        </div>
      </div>
      <LoadingIcon />
    </div>
  )
}

export default App;
